import * as React from 'react';
import CreateEventFromLasso from '../../map/modalRight/createEventFromLasso';
import { InitialMapRow } from '../../map/model';
import { FilterTree } from '../../../components_v2/filter/model/Model';
import { getCompanies } from '../data/action';
import { Company } from '../model/Model';

export default function CompanyBulkEventCreation(props: {
  type: { id: number, name: string }
  onClose: () => void
  ids: number[]
  /// `ids` is what was ticked, unless everything was, in which case it is what
  /// was unticked and `body` is what the listing was showing
  isAll?: boolean
  /// Named after what the request builder reads. It used to be a bare object,
  /// which let this be handed the filter tree under the key that builder had
  /// stopped reading: the filter was dropped without a word and selecting
  /// every row of a filtered listing created events for the whole account.
  body?: { new_filters?: FilterTree, search?: string }
  onChildChange?: (b: boolean) => void,
  onCreate?: () => void
}) {
	const { type, ids, onClose, isAll, body, onChildChange } = props;
	const [companies, setCompanies] = React.useState<Company[]>();
	const columns = [
		'name',
		'latitude',
		'longitude'
	];

	React.useEffect(() => {
		// order_bys is required and was missing, so this call never type-checked
		// and nothing it was handed was checked either — which is how the filter
		// came to be passed under a key CompanyParams does not carry
		getCompanies({ ...body, columns, order_bys: undefined }, true).then(({ companies }) => {
			if (isAll && ids.length > 0) {
				setCompanies(companies.filter(c => !ids.includes(c.company_id)));
			} else if (!isAll) {
				setCompanies(companies.filter(c => ids.includes(c.company_id)).sort((a, b) => ids.indexOf(a.company_id) - ids.indexOf(b.company_id)));
			} else {
				setCompanies(companies);
			}
		});
	}, []);

	if (companies == null) return <></>;

	return <CreateEventFromLasso
		onCreate={props.onCreate}
		type={type}
		onBack={onClose}
		noLimit
		onChildChange={onChildChange}
		v2
		noTitle
		companies={companies.map((c): InitialMapRow => ({
			id: c.company_id,
			name: c.name,
			lat: c.latitude ?? 0,
			lon: c.longitude ?? 0,
			ownerId: c.owner_id,
			clientStatusId: c.status_id,
			colorCode: c.company_status_color,
			country: c.company_country
		}))}
	/>;
}
